import React from 'react';
import PropTypes from "prop-types";
// *** Services
import { SessionActions, CertificadoActions } from "services"
// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import SimpleNotification from "components/Modal/SimpleNotification";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  }
};
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      codigo: "",
      codigoState: "",
      email: "",
      emailState: "",
      showCodigo: false,
      first: true,
      notificationOpen: false,
      notificationText: ""
    };
  }

  componentDidMount() {
    window.localStorage.clear()
  }

  handleOpenNotification = (notificationText) => {
    this.setState({ notificationOpen: true, notificationText: notificationText });
  };

  handleCloseNotification = () => {
    this.setState({
      codigo: "",
      codigoState: "",
      email: "",
      emailState: "",
      showCodigo: false,
      first: true,
      notificationOpen: false,
      notificationText: ""
    })
  }

  sendState() {
    return this.state;
  }
  handleClickShowPassword = () => {
    this.setState({showCodigo: !this.state.showCodigo });
  };
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  // function that returns true if value is email, false otherwise
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({
            [stateName + "State"]: "success",
            [stateName]: event.target.value.toUpperCase(),
            first: false
          });
        } else {
          this.setState({
            [stateName + "State"]: "error",
            [stateName]: event.target.value.toUpperCase(),
            first: false
          });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({
            [stateName + "State"]: "success",
            [stateName]: event.target.value,
            first: false
          });
        } else {
          this.setState({
            [stateName + "State"]: "error",
            [stateName]: event.target.value,
            first: false
          });
        }
        break;
      default:
        break
    }
  }
  isValidated(callback) {
    this.setState({first: false})
    if (this.state.codigoState === "success" && this.state.emailState === "success") {
      if(localStorage.getItem('token')===null){
        CertificadoActions.validaCodigo("DFES", this.state.email, this.state.codigo).then((response) => {
          switch (response.data) {
            case "error_email":
              this.handleOpenNotification("Datos incorrectos o el código ya ha sido utilizado . Para más información contáctenos:");
              break;
            case "error_cod":
              this.handleOpenNotification("Datos incorrectos o el código ya ha sido utilizado . Para más información contáctenos:");
              break;
            case false: // Violación del protocolo de comunicación con el backend. Petición incorrecta
              this.handleOpenNotification("Hubo un problema en el proceso de descarga. Intente nuevamente o contáctenos:");
              break;
            default: //case token:
              SessionActions.login(response.data).then((responseLogin)=>{ //buscar datos del usuario según token
                if(responseLogin!==undefined) //guardar data usuario en el localstorage
                {
                  localStorage.setItem('token', response.data)
                  callback(true);
                }
                else
                {
                  callback(false);
                  this.handleOpenNotification("Hubo un error en el proceso de validación. Intente nuevamente o contáctenos:")
                }
              })
              break;
          }
        })
      }
      else{
        callback(true)
      }
    } else {
      if (this.state.codigoState !== "success") {
        this.setState({ codigoState: "error" });
      }
      if (this.state.emailState !== "success") {
        this.setState({ emailState: "error"});
      }
      callback(false);
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {/* {this.state.AlertisFormValid===false? null:
                  <Snackbar open={true} autoHideDuration={6000} >
                    <Alert severity="error" >
                      <b>ERROR:</b> {this.state.TestError}
                    </Alert>
                  </Snackbar>} */}

        <GridContainer justify="center">
          <GridItem xs={12} sm={12}>
            <h4 className={classes.infoText} style={{fontWeight:"400", marginBottom:"10px"}}>Ingresa los datos requeridos</h4>
            <div style={{fontWeight:"400",textTransform: "none", textAlign: "center"}}>Debes utilizar el correo empleado en la compra del certificado y</div>
            <div style={{fontWeight:"400", textTransform: "none", textAlign: "center"}}>el código recibido al finalizar la misma.</div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={10}>
            <CustomInput
              success={this.state.emailState === "success"}
              error={this.state.first ? false : this.state.emailState === "error"}
              errMsg={this.state.emailState === "error" && this.state.email === "" ? "El correo es requerido" : "El correo no es válido"}
              labelText={
                <span style={{ textTransform: "capitalize" }}>
                  <span style={{color:"red", paddingRight:"5px"}}>*</span>
                  <span>Correo Electrónico</span>
                </span>
              }

              id="email"
              formControlProps={{
                fullWidth: true,
                style: {textTransform: 'uppercase'}
              }}
              inputProps={{
                value: this.state.email,
                maxLength: 100,
                style: { textTransform: 'uppercase' },
                onChange: event => this.change(event, "email", "email", 0),
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <MailOutline className={classes.inputAdornmentIcon} style={{marginLeft:"10", marginRight:"10px"}}/>
                  </InputAdornment>
                )
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={10}>
            <CustomInput
              success={this.state.codigoState === "success"}
              error={ this.state.first ? false : this.state.codigoState === "error"}
              errMsg={this.state.codigoState === "error" ? "El código es requerido" : ""}
              labelText={
                <span style={{ textTransform: "capitalize" }}>
                  <span style={{color:"red", paddingRight:"5px"}}>*</span>
                  <span>Código</span>
                </span>
              }
              id="codigo"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: this.state.codigo,
                type:this.state.showCodigo ? 'text' : 'password',
                onChange: event => this.change(event, "codigo", "length", 3),
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={this.handleClickShowPassword}
                      onMouseDown={this.handleMouseDownPassword}
                      style={{padding:"10"}}
                    >
                      {this.state.showCodigo
                        ? <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                          </svg>
                        : <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M12 6a9.77 9.77 0 0 1 8.82 5.5a9.647 9.647 0 0 1-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68A11.738 11.738 0 0 0 1 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42l1.41-1.41L3.42 2.45L2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 0 1-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 0 0-.36 1.78a4.507 4.507 0 0 0 6.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 0 1-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z" />
                          </svg>
                      }
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </GridItem>
          <SimpleNotification
            openNotification={this.state.notificationOpen}
            onClose={this.handleCloseNotification}
            notificationText={this.state.notificationText}
          />

        </GridContainer>
      </div>
    );
  }
}

Step1.propTypes = {
  classes: PropTypes.object
};

export default withStyles(style)(Step1);
